import '../newstyle/css/aila-services.scss'

let carouselInstances = {};

document.addEventListener("turbolinks:load", function() {
  // Scroll to top on page load
  window.scrollTo(0, 0);

  // Scroll
  $('.scroll-link[href^="#"]').on('click', function (e) {
    const targetId = $(this).attr('href');
  
    if (targetId.length > 1 && $(targetId).length) {
      e.preventDefault();
  
      const targetElement = $(targetId);
      const targetPosition = targetElement.offset().top;
  
      smoothScroll(targetPosition);
    }
  });
  
  function smoothScroll(targetPosition) {
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    const duration = 500;
    let startTime = null;
  
    const scrollStep = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
  
      window.scrollTo(0, startPosition + distance * progress);
  
      if (timeElapsed < duration) {
        requestAnimationFrame(scrollStep);
      }
    };
  
    requestAnimationFrame(scrollStep);
  }

  // Carrega o video
  function onYouTubeIframeAPIReady() {
    const iframe = $('<iframe>', {
      width: '100%',
      height: '100%',
      src: 'https://www.youtube.com/embed/olo719vC5C0?enablejsapi=1',
      frameborder: '0',
      allow: 'accelerometer; encrypted-media; gyroscope; picture-in-picture',
      allowfullscreen: ''
    });
  
    $('.hero__video').empty().append(iframe);
  
    new YT.Player(iframe[0], {
      events: {
        'onReady': onPlayerReady
      }
    });
  }
  
  function onPlayerReady(event) {
    event.target.setVolume(50);
  }
  
  $(document).ready(function () {
    $('.hero__video__play-button').on('click', function () {
      if (typeof YT !== 'undefined' && YT.Player) {
        onYouTubeIframeAPIReady();
      }
    });
  });

  // Carousel
  function Carousel(selector) {
    this.selector = selector;
    this.container = $(selector);
    this.carousel = this.container.find('.carousel');
    this.slides = this.container.find('.slide');
    this.progressContainer = this.container.find('.progress-container');
    this.progressBars = [];
    this.currentSlide = 0;
    this.autoPlayInterval = null;

    if (carouselInstances[selector]) {
      carouselInstances[selector].destroy();
    }
  
    this.init();
    this.createProgressBars();
    this.startAutoPlay();
    this.addEventListeners();
    carouselInstances[selector] = this
  }
  
  Carousel.prototype.init = function() {
    this.slides.each((index, slide) => {
      $(slide).css({
        'transform': `translateX(${100 * index}%)`,
        'transition': 'transform 0.5s ease'
      });
    });
  };
  
  Carousel.prototype.createProgressBars = function() {
    this.progressContainer.empty();
    this.progressBars = [];
    this.slides.each((index) => {
      const button = $('<button>').addClass('progress-bar').attr('aria-label', `slide ${index + 1}`);
      if (index === 0) button.addClass('active');
      this.progressContainer.append(button);
      this.progressBars.push(button);
    });
    
    // Transformando progressBars em jQuery
    this.progressBars = $(this.progressBars);
  };
  
  Carousel.prototype.goToSlide = function(index) {
    this.slides.each((i, slide) => {
      $(slide).css('transform', `translateX(${100 * (i - index)}%)`);
    });
  
    this.progressBars.each((i, bar) => {
      $(bar).toggleClass('active', i === index);
    });
  
    this.currentSlide = index;
  };
  
  Carousel.prototype.nextSlide = function() {
    const next = (this.currentSlide + 1) % this.slides.length;
    this.goToSlide(next);
  };
  
  Carousel.prototype.startAutoPlay = function() {
    this.stopAutoPlay();
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, 3000);
  };
  
  Carousel.prototype.stopAutoPlay = function() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  };
  
  Carousel.prototype.addEventListeners = function() {
    this.progressBars.each((index, bar) => {
      $(bar).on('click', () => {
        this.stopAutoPlay();
        this.goToSlide(index);
        this.startAutoPlay();
      });
    });
  };

  Carousel.prototype.destroy = function() {
    this.stopAutoPlay();
    this.progressBars.each((index, bar) => {
      $(bar).off('click');
    });
  };

  if ($('#cards-carousel').length) {
    new Carousel('#cards-carousel');
  }
  
  if ($('#services-carousel').length) {
    new Carousel('#services-carousel');
  }
})
